require.register("app/restaurant/copy/PriceAndStockForm", function(exports, require, module){
  $0
  
});

